import React from "react";

const SkeletonPostCard: React.FC = () => (
  <div className="bg-white/40 dark:bg-slate-900/40 backdrop-blur-md border border-white/20 dark:border-slate-800/50 mb-6 overflow-hidden animate-pulse rounded-[32px] mx-4 shadow-sm">
    <div className="p-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="space-y-2">
          <div className="h-3 w-24 bg-slate-200 dark:bg-slate-800 rounded" />
          <div className="h-2 w-16 bg-slate-100 dark:bg-slate-800/50 rounded" />
        </div>
      </div>
      <div className="w-8 h-8 rounded-full bg-slate-50 dark:bg-slate-800/30" />
    </div>

    <div className="px-8 py-12 bg-slate-50/50 dark:bg-slate-800/20 flex flex-col items-center gap-4">
      <div className="h-4 w-3/4 bg-slate-200 dark:bg-slate-800 rounded" />
      <div className="h-4 w-1/2 bg-slate-200 dark:bg-slate-800 rounded" />
      <div className="h-4 w-2/3 bg-slate-200 dark:bg-slate-800 rounded" />
    </div>

    <div className="px-4 py-4 flex justify-between items-center">
      <div className="flex gap-6">
        <div className="h-5 w-10 bg-slate-100 dark:bg-slate-800 rounded-full" />
        <div className="h-5 w-10 bg-slate-100 dark:bg-slate-800 rounded-full" />
        <div className="h-5 w-10 bg-slate-100 dark:bg-slate-800 rounded-full" />
      </div>
      <div className="h-5 w-5 bg-slate-100 dark:bg-slate-800 rounded" />
    </div>
  </div>
);

export default SkeletonPostCard;
